var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"games"},_vm._l((_vm.games),function(game,idx){return _c('li',{key:`game-${idx}`,staticClass:"games__item"},[_c('game-btn',{attrs:{"label":game.label,"prefix":"fill"},on:{"btnEvent":function($event){return _vm.changeRoute(game.route)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }